import ls from '@babyeyefe/localstorage'

const TokenKey = 'BE-SQ-TOKEN'

export function getToken() {
  return ls.get(TokenKey)
}

export function setToken(token) {
  return ls.set(TokenKey, token)
}

export function removeToken() {
  return ls.remove(TokenKey)
}

export function setAccount(account) {
  return ls.set(
    'account',
    JSON.stringify({ data: account, time: new Date().getTime() })
  )
}

export function setPassword(password) {
  return ls.set(
    'password',
    JSON.stringify({ data: password, time: new Date().getTime() })
  )
}

export function getAccount() {
  let data = ls.get('account')
  console.log(data)
  if (!data) {
    return ''
  } else {
    let dataObj = JSON.parse(data)
    if (new Date().getTime() - dataObj.time > 1000 * 3600 * 24 * 7) {
      return ls.remove('account')
    } else {
      return dataObj.data
    }
  }
}

export function getPassword() {
  let data = ls.get('password')
  if (!data) {
    return ''
  } else {
    let dataObj = JSON.parse(data)
    if (new Date().getTime() - dataObj.time > 1000 * 3600 * 24 * 7) {
      return ls.remove('password')
    } else {
      return dataObj.data
    }
  }
}

export function removeAccount() {
  return ls.remove('account')
}

export function removePassword() {
  return ls.remove('password')
}

export function setRole(role) {
  return ls.set('role', role)
}

export function getRole() {
  return ls.get('role')
}
